(() => {
  const closeLabel = document.currentScript?.dataset.closeIngredientLabel;
  const addLabel = document.currentScript?.dataset.addFlavourLabel;
  const removeLabel = document.currentScript?.dataset.removeFlavourLabel;
  const initialized = new WeakSet();

  function enableKeyboardButton(control) {
    if (control.matches('button, a[href], input')) return;
    control.setAttribute('role', 'button');
    control.tabIndex = 0;
    control.addEventListener('keydown', (event) => {
      if (event.target !== control || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      if (!event.repeat) control.click();
    });
  }

  function boot(root = document) {
    root.querySelectorAll('.build-a-bundle__collection-group-product.bundle-card').forEach((card) => {
      const title = card.querySelector('.build-a-bundle__collection-group-product-title')?.textContent.trim();
      if (!title) return;
      if (addLabel) card.querySelectorAll('button.bundle-card__quantity-plus').forEach((button) => {
        button.setAttribute('aria-label', addLabel.replace('[flavour]', title));
      });
      if (removeLabel) card.querySelectorAll('button.bundle-card__quantity-minus').forEach((button) => {
        button.setAttribute('aria-label', removeLabel.replace('[flavour]', title));
      });
    });

    root.querySelectorAll('[class^="feature-toggle-"]').forEach((control, index) => {
      if (initialized.has(control)) return;
      const item = control.closest('[class^="feature-feature-"]');
      const answer = item?.querySelector('[class^="feature-feature-text-"]');
      if (!item || !answer) return;
      initialized.add(control);
      const sectionId = item.closest('.shopify-section')?.id || 'eleat-feature';
      answer.id ||= `${sectionId}-${item.id || index}-answer`;
      control.setAttribute('aria-controls', answer.id);
      enableKeyboardButton(control);
      const sync = () => control.setAttribute('aria-expanded', String(item.classList.contains('active')));
      new MutationObserver(sync).observe(item, {attributes: true, attributeFilter: ['class']});
      item.querySelector('[class^="feature-height-cal-"]')?.setAttribute('aria-hidden', 'true');
      sync();
    });

    root.querySelectorAll('[class^="ingredients-source-icon-"]').forEach((control) => {
      if (initialized.has(control)) return;
      const token = [...control.classList].find((name) => name.startsWith('ingredients-source-icon-'));
      const suffix = token?.slice('ingredients-source-icon-'.length);
      if (!suffix) return;
      const modal = document.querySelector(`.ingredients-modal-${suffix}`);
      const inner = modal?.querySelector(`.ingredients-modal-inner-${suffix}`);
      const close = modal?.querySelector(`.ingredients-close-modal-${suffix}`);
      const card = control.closest(`.ingredients-slide-${suffix}`);
      const title = card?.querySelector(`.ingredients-title-${suffix}`)?.textContent.trim();
      if (!modal || !inner || !close || !title) return;
      initialized.add(control);
      enableKeyboardButton(control);
      modal.id ||= `eleat-ingredients-dialog-${suffix}`;
      control.setAttribute('aria-label', title);
      control.setAttribute('aria-haspopup', 'dialog');
      control.setAttribute('aria-controls', modal.id);
      control.setAttribute('aria-expanded', 'false');

      if (initialized.has(modal)) return;
      initialized.add(modal);
      close.type = 'button';
      if (closeLabel) close.setAttribute('aria-label', closeLabel);
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      let opener = null;
      let wasOpen = false;
      const controls = [...document.querySelectorAll(`.ingredients-source-icon-${suffix}`)];
      controls.forEach((trigger) => trigger.addEventListener('click', () => { opener = trigger; }));

      const sync = () => {
        const open = modal.classList.contains('active') && inner.classList.contains('active');
        const panel = modal.querySelector(`.ingredients-modal-content-${suffix}.active`);
        const heading = panel?.querySelector(`.ingredients-sidebar-title-${suffix}`);
        if (heading) {
          heading.id ||= `${modal.id}-${panel.dataset.id}-title`;
          modal.setAttribute('aria-labelledby', heading.id);
        }
        modal.setAttribute('aria-hidden', String(!open));
        controls.forEach((trigger) => trigger.setAttribute('aria-expanded', String(open && trigger === opener)));
        if (open && !wasOpen) close.focus({preventScroll: true});
        if (!open && wasOpen && opener?.isConnected) opener.focus({preventScroll: true});
        wasOpen = open;
      };
      new MutationObserver(sync).observe(modal, {
        attributes: true, attributeFilter: ['class'], subtree: true
      });
      modal.addEventListener('keydown', (event) => {
        if (!wasOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          close.click();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...inner.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first || !last) return;
        if (event.shiftKey && (document.activeElement === first || !inner.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !inner.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      });
      sync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
